import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import { _axios } from '../../utils/axios';

const EditReportSafety = ({ show, onHide, reportData }) => {
    const [formData, setFormData] = useState({
        report_id: '',
        raw_id: '', // Added raw_id to store the original numeric ID
        user_name: '',
        issue_category: '',
        urgency_level: '',
        evidence_description: '',
        status: '',
        evidence_media: null
    });
    const [loading, setLoading] = useState(false);

    const formatUrgencyLevel = (level) => {
  if (!level) return '';
  return level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
};

    // Format category name (remove underscores and capitalize words)
    const formatCategoryName = (category) => {
        if (!category) return '';
        return category
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    useEffect(() => {
        if (reportData) {
            // Log the incoming status for debugging
            console.log("Incoming status from reportData:", reportData.status);
            
            // Make sure status is either 'Open' or 'Closed'
            let statusValue = 'Open';
            if (reportData.status === 'Closed' || reportData.status === 'Close' || reportData.status === 0) {
                statusValue = 'Closed';
            }
            
            console.log("Status value being set in form:", statusValue);
            
            setFormData({
                report_id: reportData.report_id || '',
                raw_id: reportData.raw_id || reportData.id || '', // Use raw_id if available, fall back to id
                user_name: reportData.user_name || '',
                issue_category: formatCategoryName(reportData.issue_category) || '',
                urgency_level: formatUrgencyLevel(reportData.urgency_level) || '',
                evidence_description: reportData.evidence_description || '',
                status: statusValue,
                evidence_media: reportData.evidence_media || null
            });
        }
    }, [reportData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Only allow status to be changed
        if (name === 'status') {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let reportIdNumber;

            // Use the raw_id if available (this should be the most reliable method)
            if (formData.raw_id) {
                reportIdNumber = formData.raw_id;
            } 
            // If raw_id is not available, try to extract from the formatted ID
            else if (typeof formData.report_id === 'string') {
                // Check if it's in the format RSY-20250507-027
                const parts = formData.report_id.split('-');
                if (parts.length >= 3) {
                    // Extract just the last part (e.g., "027" -> 27)
                    reportIdNumber = parseInt(parts[parts.length - 1].replace(/^0+/, ''), 10);
                } else {
                    // Fallback for older format or other formats
                    reportIdNumber = parseInt(formData.report_id.replace(/\D/g, ''), 10);
                }
            } else {
                // Last fallback for any other cases
                reportIdNumber = formData.report_id;
            }

            // Log for debugging
            console.log("Current status value:", formData.status);
            
            // Convert status string to numeric value (Open = 1, Closed = 0)
            const statusValue = formData.status === 'Open' ? 1 : 0;
            
            console.log("Status value being sent to API:", statusValue);

            const response = await _axios.put(`${ServerPath}/report-safety-issue/update-status`, {
                report_id: reportIdNumber,
                status: statusValue
            });

            if (response.data.success) {
                toast.success('Report status updated successfully');
                onHide(); // Close the modal
            } else {
                toast.error(response.data.message || 'Failed to update report status');
            }
        } catch (error) {
            console.error('Error updating report status:', error);
            toast.error('An error occurred while updating the report status');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Edit Report Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Issue Category</Form.Label>
                                <Form.Select
                                    name="issue_category"
                                    value={formData.issue_category}
                                    disabled
                                    className="bg-light"
                                >
                                    <option value={formData.issue_category}>{formData.issue_category}</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-md-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Urgency Level</Form.Label>
                                <Form.Select
                                    name="urgency_level"
                                    value={formData.urgency_level}
                                    disabled
                                    className="bg-light"
                                >
                                    <option value={formData.urgency_level}>{formData.urgency_level}</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label>Evidence Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="evidence_description"
                                    value={formData.evidence_description}
                                    disabled
                                    className="bg-light"
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    className="form-control"
                                >
                                    <option value="Open">Open</option>
                                    <option value="Closed">Closed</option>
                                </Form.Select>
                            </Form.Group>
                        </div>

                        {formData.evidence_media && (
                            <div className="col-md-9">
                                <Form.Group className="mb-3">
                                    <Form.Label>Evidence Images</Form.Label>
                                    <div className="evidence-images-container d-flex gap-2">
                                        <div className="evidence-image-item">
                                            <img
                                                src={formData.evidence_media}
                                                alt="Evidence"
                                                className="img-fluid border rounded"
                                                style={{ maxHeight: '150px', objectFit: 'cover' }}
                                            />
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            style={{
                                backgroundColor: '#5C61F2',
                                borderColor: '#5C61F2',
                                borderRadius: '4px',
                                padding: '8px 20px'
                            }}
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditReportSafety;